// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__ringside_compressed_82a49e', '__ringside_compressed_Fallback_82a49e'"},"className":"__className_82a49e","variable":"__variable_82a49e"};